/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popAward.vue?vue&type=template&id=19eaab8d&scoped=true"
import script from "./popAward.vue?vue&type=script&lang=js"
export * from "./popAward.vue?vue&type=script&lang=js"
import style0 from "./popAward.vue?vue&type=style&index=0&id=19eaab8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19eaab8d",
  null
  
)

export default component.exports